import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import AngularUtilsModule from '@aida/shared-angular-utils/angular-utils.module';
import AuthInterceptor from '@aida/shared-angular-utils/auth/auth.interceptor';
import ErrorInterceptor from '@aida/shared-angular-utils/http-resilient/http-error.interceptor';
import HttpRetryConfig from '@aida/shared-angular-utils/http-resilient/http-retry.config';
import HttpRetryInterceptor from '@aida/shared-angular-utils/http-resilient/http-retry.interceptor';

import { AppRoutingModule } from './app-routing.module';
import AppComponent from './app.component';
import environment from '../environments/environment';
import { CommonUtils } from './common/utils/environment/commonUtils';
import { FeaturesModule } from './features/features.module';
import { ToastEffects } from './features/shared/state/toast/toast.effects';
import OktaCallbackComponent from './okta-callback/okta-callback.component';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { metaReducers, reducers } from './reducers';
import SharedModule from './shared/shared.module';

const oktaAuth = new OktaAuth(environment.oktaConfig);

// Resolves a known issue with Okta by initiating a new login flow.
// Stale/Invalid sessions resulting in OAuthError "The client specified not to prompt, but the user isn't signed in."
// oktaAuth.tokenManager.on('error', async (err: TokenManagerError) => {
//     if (err.errorCode === 'login_required') {
//         console.log('OAuthError: Caught known error with Okta sessions');
//         console.log(err.message);
//         await delay(1_000);
//         oktaAuth.signInWithRedirect();
//     }
// });

@NgModule({
    declarations: [AppComponent, OktaCallbackComponent],
    bootstrap: [AppComponent],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        OktaAuthModule,
        SharedModule,
        AngularUtilsModule,
        FeaturesModule,
        EffectsModule.forFeature([ToastEffects]),
        EffectsModule.forRoot([]),
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreRouterConnectingModule.forRoot({
            stateKey: 'router',
        }),
        StoreDevtoolsModule.instrument({
            name: 'NgRx Store DevTools',
            logOnly: environment.production,
        }),
        // FeaturesSharedModule,
        FormsModule,
        // DomainModule,
        DashboardModule,
    ],
    providers: [
        CommonUtils,
        Title,
        /**
         * The `RouterStateSnapshot` provided by the `Router` is a large complex structure.
         * A custom RouterStateSerializer is used to parse the `RouterStateSnapshot` provided
         * by `@ngrx/router-store` to include only the desired pieces of the snapshot.
         */

        { provide: OKTA_CONFIG, useValue: { oktaAuth } },
        { provide: HttpRetryInterceptor },
        { provide: HttpRetryInterceptor.HTTP_RETRY_CONFIG, useValue: HttpRetryConfig },
        { provide: ErrorInterceptor, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export default class AppModule {}
